import React from 'react';
import { observer } from 'mobx-react';

import PageComponent from 'js/components/pages/PageComponent';
import { makeRequest } from 'js/services/Network';
import { lightGrey1Color } from 'js/config/style';

import ItemManageStatusPageState from 'js/stores/pages/ItemManageStatusPageState';
import ItemStatusPage from './ItemStatusPage';

@observer
export default class ManageItemPage extends PageComponent {
  loginRequired = true;
  pageName = 'ManageItemPage';
  trackingName = 'SP_manage_item';
  pageColor = lightGrey1Color;
  backNav = 'preserve';
  pageWidth = '400px';

  bootstrap = () => makeRequest('manage-item-data', this.props).then(({ data }) => this[`${data.mode}Init`](data));
  renderPage = () => {
    return this[`${this.page.mode}Render`]();
  }

  itemInit = statusData => (this.page = ItemManageStatusPageState.create(statusData));
  itemRender = () => <ItemStatusPage />;
}
